import App from '@/App.vue'

export type AppRootComponent = typeof App

export function getRootComponent(): AppRootComponent {
  return App
}
